import { useRef, useState } from "react";
import { useScroll, useMotionValueEvent } from "framer-motion";

const VIDEO_URL = "https://customer-assets.emergentagent.com/job_coco-connect-1/artifacts/87813v2y_BCC%202.mp4";
const POSTER = "https://images.unsplash.com/photo-1641266886439-4fe7852df25c";

// Fixed full-screen video that scrubs from 0 -> duration across the whole page scroll.
export const FixedVideo = () => {
  const videoRef = useRef(null);
  const [ready, setReady] = useState(false);
  const { scrollYProgress } = useScroll();

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    const vid = videoRef.current;
    if (vid && vid.duration) {
      const target = Math.min(vid.duration - 0.05, Math.max(0, v * vid.duration));
      if (Math.abs(vid.currentTime - target) > 0.02) {
        try { vid.currentTime = target; } catch (e) {}
      }
    }
  });

  return (
    <div className="fixed inset-0 z-0" data-testid="fixed-video">
      <video
        ref={videoRef}
        src={VIDEO_URL}
        poster={POSTER}
        muted
        playsInline
        preload="auto"
        onLoadedMetadata={() => setReady(true)}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      {!ready && <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 text-xs">Loading journey…</div>}
    </div>
  );
};
